import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, filter, Observable, shareReplay, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { FileInterface } from '@interfaces/file.interface';
import { environment } from '@environments/environment';

/**
 * current user profile http service
 */
@Injectable({
  providedIn: 'root',
})
export class CurrentUserProfileHttpService {
  private currentUserPicture$: Observable<FileInterface> | null = null;
  private currentUserPictureUrlSubject = new BehaviorSubject<string | null>(null);
  currentUserPictureUrl$ = this.currentUserPictureUrlSubject.asObservable();

  constructor(private httpClient: HttpClient) {}

  /**
   * upload current user picture
   * @param formData - file details
   */
  uploadCurrentUserPicture(formData: FormData): Observable<FileInterface> {
    this.currentUserPicture$ = null;
    const url = `${environment.apiHostV2}/members/current/profile-picture`;

    return this.httpClient.put<FileInterface>(url, formData).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error)),
      tap((file: FileInterface) => {
        const path = file.filePath + `&t=${Date.now()}`;
        this.currentUserPictureUrlSubject.next(path);
      }),
    );
  }

  /**
   * get current user picture
   * @param forceReload
   */
  getCurrentUserPicture(forceReload: boolean = false): Observable<FileInterface> {
    if (!this.currentUserPicture$ || forceReload) {
      const url = `${environment.apiHostV2}/members/current/profile-picture`;
      this.currentUserPicture$ = this.httpClient.get<FileInterface>(url).pipe(
        filter((response) => Boolean(response)),
        shareReplay(1),
        tap((file: FileInterface) => {
          if (file) {
            const path = file?.filePath + `&t=${Date.now()}`;
            this.currentUserPictureUrlSubject.next(path);
          }
        }),
        catchError((error: HttpErrorResponse) => {
          this.currentUserPicture$ = null;
          return throwError(() => error);
        }),
      );
    }

    return this.currentUserPicture$;
  }
}
